export default "__VITE_ASSET__D31$F1WC__"